
import * as React from "react"
import { useI18next } from 'gatsby-plugin-react-i18next';

const EmojiDescription = ({ emoji }) => {
    const {language} = useI18next();

    return (
        <div>
            <p className="mb-4">{ emoji.description[language] || emoji.description.en }</p>
        </div>
    )
}

export default EmojiDescription
